import { render, staticRenderFns } from "./ValidarRespuestaModal.vue?vue&type=template&id=f4872148&scoped=true&"
import script from "./ValidarRespuestaModal.vue?vue&type=script&lang=ts&"
export * from "./ValidarRespuestaModal.vue?vue&type=script&lang=ts&"
import style0 from "./ValidarRespuestaModal.vue?vue&type=style&index=0&id=f4872148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4872148",
  null
  
)

export default component.exports